import personApi from '../../../api/person/PersonApi'
import { CsPersonSearchResultDto } from '../../../api/person/models/searchCs/SearchPersonsCsDtos'
import { LinkNewUserToTenantRes } from '../../../api/person/PersonApi'
import { normalizeLinkedInProfileUrl } from '../../../utils/linkedin'

type CompleteLinkedInSignupArgs = {
    linkedinUrl: string
    person?: CsPersonSearchResultDto | null
    workHistoryId?: string
}

export async function completeLinkedInSignup({
    linkedinUrl,
    person,
    workHistoryId,
}: CompleteLinkedInSignupArgs): Promise<LinkNewUserToTenantRes> {
    const normalizedUrl = normalizeLinkedInProfileUrl(linkedinUrl)

    if (!normalizedUrl) {
        throw new Error(
            'Please enter a full LinkedIn profile URL like https://www.linkedin.com/in/your-name.',
        )
    }

    if (person) {
        await personApi.importPersonAndLinkToUser({ personId: person.id })
    }

    return personApi.linkNewUserToTenant({
        linkedinUrl: normalizedUrl,
        personId: person?.id,
        workHistoryId,
    })
}
